var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 56,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77205 5.99375L0 10.7437V2C0 0.896875 0.896933 0 2.00013 0H5.67224C6.20353 0 6.71294 0.209375 7.08796 0.584375L7.91614 1.4125C8.29116 1.7875 8.80057 1.99688 9.33186 1.99688H13.0008C14.104 1.99688 15.001 2.89375 15.001 3.99687V4.99687H4.50029C3.78775 4.99687 3.13145 5.375 2.77205 5.99062V5.99375ZM3.63461 6.49687C3.81587 6.1875 4.14402 6 4.50029 6H17.0011C17.3605 6 17.6887 6.19063 17.8668 6.50313C18.0449 6.81563 18.0449 7.19688 17.8637 7.50625L14.3634 13.5063C14.1853 13.8125 13.8572 14 13.5009 14H1.00006C0.640667 14 0.31252 13.8094 0.134384 13.4969C-0.0437528 13.1844 -0.0437528 12.8031 0.137509 12.4937L3.63774 6.49375L3.63461 6.49687Z",
    fill: "#233C7E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBig);
export default __webpack_public_path__ + "static/media/folderBig.ca7a99b34f1705dc49a3e9664f3df076.svg";
export { ForwardRef as ReactComponent };